import * as React from "react";
import ReactDOM from "react-dom";

export class Pivot extends React.Component {

	webdatarocks;

	propTypes: {
		global: React.PropTypes.object,
		width: [React.PropTypes.string, React.PropTypes.number],
		height: [React.PropTypes.string, React.PropTypes.number],
		report: [React.PropTypes.string, React.PropTypes.object],
		toolbar: React.PropTypes.bool,
		customizeCell: React.PropTypes.func,
		cellclick: React.PropTypes.func,
		celldoubleclick: React.PropTypes.func,
		dataerror: React.PropTypes.func,
		datafilecancelled: React.PropTypes.func,
		dataloaded: React.PropTypes.func,
		datachanged: React.PropTypes.func,
		fieldslistclose: React.PropTypes.func,
		fieldslistopen: React.PropTypes.func,
		filteropen: React.PropTypes.func,
		fullscreen: React.PropTypes.func,
		loadingdata: React.PropTypes.func,
		loadinglocalization: React.PropTypes.func,
		loadingreportfile: React.PropTypes.func,
		localizationerror: React.PropTypes.func,
		localizationloaded: React.PropTypes.func,
		openingreportfile: React.PropTypes.func,
		querycomplete: React.PropTypes.func,
		queryerror: React.PropTypes.func,
		ready: React.PropTypes.func,
		reportchange: React.PropTypes.func,
		reportcomplete: React.PropTypes.func,
		reportfilecancelled: React.PropTypes.func,
		reportfileerror: React.PropTypes.func,
		reportfileloaded: React.PropTypes.func,
		runningquery: React.PropTypes.func,
		update: React.PropTypes.func,
		beforetoolbarcreated: React.PropTypes.func
	}

	render() {
		let me = this;
		if (me.webdatarocks) {
			me.webdatarocks.updateData({
				data: me.props.datasource
			});
			let reports = me.webdatarocks.getReport();
			reports.slice = me.props.slice;
			me.webdatarocks.setReport(reports);
			me.webdatarocks.refresh();
		}
		return (
			<div> Pivot </div>
		)
	}

	customizeToolbar(toolbar) {
		var tabs = toolbar.getTabs(); // get all tabs from the toolbar
		toolbar.getTabs = function () {
			delete tabs[0]; // delete the 'Connect' tab
			delete tabs[1]; // delete the 'Open' tab
			delete tabs[2]; // delete the 'Save' tab
			delete tabs[4]; // delete the 'Save' 
			return tabs;
		}
	}
	componentDidMount() {
		var config = {
			global: {
				localization: "https://cdn.webdatarocks.com/loc/es.json"
			},
			options: {
				grid: {
					title: "Datos de series",
					type: "flat",
					showTotals: "off",
					showGrandTotals: "off",
					showFilter: false,
					showHeaders: false
				}
			},
			formats: [{
				"name": "",
				"thousandsSeparator": " ",
				"decimalSeparator": ".",
				"decimalPlaces": 2,
				"maxSymbols": 20,
				"currencySymbol": "",
				"currencySymbolAlign": "left",
				"nullValue": " ",
				"infinityValue": "Infinity",
				"divideByZeroValue": "Infinity"
			}],
			beforetoolbarcreated: this.customizeToolbar
		};
		config.container = ReactDOM.findDOMNode(this);
		this.parseProps(config);
		this.webdatarocks = new window.WebDataRocks(config);
	}

	shouldComponentUpdate() {
		return true;
	}

	componentWillUnmount() {
		this.webdatarocks.dispose();
	}

	parseProps(config) {
		if (this.props.option !== undefined) {
			config.options = this.props.option;
		}
		if (this.props.toolbar !== undefined) {
			config.toolbar = this.props.toolbar;
		}
		if (this.props.width !== undefined) {
			config.width = this.props.width;
		}
		if (this.props.height !== undefined) {
			config.height = this.props.height;
		}
		if (this.props.report !== undefined) {
			config.report = this.props.report;
		}
		if (this.props.datasource !== undefined) {
			config.report = {
				dataSource: {
					data: this.props.datasource
				},
				options: config.options
			};
		}
		if (this.props.slice !== undefined) {
			config.report.slice = this.props.slice;
		}
		if (this.props.global !== undefined) {
			config.global = this.props.global;
		}
		if (this.props.customizeCell !== undefined) {
			config.customizeCell = this.props.customizeCell;
		}
		// events
		if (this.props.cellclick !== undefined) {
			config.cellclick = this.props.cellclick;
		}
		if (this.props.celldoubleclick !== undefined) {
			config.celldoubleclick = this.props.celldoubleclick;
		}
		if (this.props.dataerror !== undefined) {
			config.dataerror = this.props.dataerror;
		}
		if (this.props.datafilecancelled !== undefined) {
			config.datafilecancelled = this.props.datafilecancelled;
		}
		if (this.props.dataloaded !== undefined) {
			config.dataloaded = this.props.dataloaded;
		}
		if (this.props.datachanged !== undefined) {
			config.datachanged = this.props.datachanged;
		}
		if (this.props.fieldslistclose !== undefined) {
			config.fieldslistclose = this.props.fieldslistclose;
		}
		if (this.props.fieldslistopen !== undefined) {
			config.fieldslistopen = this.props.fieldslistopen;
		}
		if (this.props.filteropen !== undefined) {
			config.filteropen = this.props.filteropen;
		}
		if (this.props.fullscreen !== undefined) {
			config.fullscreen = this.props.fullscreen;
		}
		if (this.props.loadingdata !== undefined) {
			config.loadingdata = this.props.loadingdata;
		}
		if (this.props.loadinglocalization !== undefined) {
			config.loadinglocalization = this.props.loadinglocalization;
		}
		if (this.props.loadingreportfile !== undefined) {
			config.loadingreportfile = this.props.loadingreportfile;
		}
		if (this.props.localizationerror !== undefined) {
			config.localizationerror = this.props.localizationerror;
		}
		if (this.props.localizationloaded !== undefined) {
			config.localizationloaded = this.props.localizationloaded;
		}
		if (this.props.openingreportfile !== undefined) {
			config.openingreportfile = this.props.openingreportfile;
		}
		if (this.props.querycomplete !== undefined) {
			config.querycomplete = this.props.querycomplete;
		}
		if (this.props.queryerror !== undefined) {
			config.queryerror = this.props.queryerror;
		}
		if (this.props.ready !== undefined) {
			config.ready = this.props.ready;
		}
		if (this.props.reportchange !== undefined) {
			config.reportchange = this.props.reportchange;
		}
		if (this.props.reportcomplete !== undefined) {
			config.reportcomplete = this.props.reportcomplete;
		}
		if (this.props.reportfilecancelled !== undefined) {
			config.reportfilecancelled = this.props.reportfilecancelled;
		}
		if (this.props.reportfileerror !== undefined) {
			config.reportfileerror = this.props.reportfileerror;
		}
		if (this.props.reportfileloaded !== undefined) {
			config.reportfileloaded = this.props.reportfileloaded;
		}
		if (this.props.runningquery !== undefined) {
			config.runningquery = this.props.runningquery;
		}
		if (this.props.update !== undefined) {
			config.update = this.props.update;
		}
		if (this.props.beforetoolbarcreated !== undefined) {
			config.beforetoolbarcreated = this.props.beforetoolbarcreated;
		}
	}

}